/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, PropsWithChildren, useCallback, useState } from 'react';
import { useQuery } from 'react-query';

import { MaintenancePage } from '../../pages/MaintenancePage/component';
import { fetchSystemStatus } from '../../utils/queryFns';

const ERROR_COUNT_THRESHOLD = 3;

export const BackendHealthyContainer = memo<PropsWithChildren>(({ children }) => {
  const [errorCount, setErrorCount] = useState(0);

  const handlePingSuccess = useCallback(() => setErrorCount(0), [setErrorCount]);
  const handlePingError = useCallback(() => {
    setTimeout(handleRefetch, 1000);
    setErrorCount(count => count + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setErrorCount]);

  const statusQuery = useQuery([fetchSystemStatus.key], fetchSystemStatus.fn, {
    onSuccess: handlePingSuccess,
    onError: handlePingError,
    retry: 1,
    retryDelay: 0,
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  const handleRefetch = useCallback(() => statusQuery.refetch(), [statusQuery]);

  return errorCount >= ERROR_COUNT_THRESHOLD ? <MaintenancePage /> : children;
});
